<template>
  <div class="create-order">
    <div class="flex items-center bg-neutral-700 py-10 px-40 stepper relative mdmax:px-4 mdmax:text-center mdmax:gap-2 mdmax:-mx-4 mdmax:py-6 mdmax:items-stretch">
      <div class="flex-1 py-2 px-6 rounded bg-primary-100 mdmax:pl-3 mdmax:pr-3" :class="{ arrow: !isMobile }">
        <p class="text-sm font-medium ">{{ $t('order.createOrder.stepOne.title') }}</p>
        <p class="text-xs text-neutral-500">{{ $t('order.createOrder.stepOne.desc') }}</p>
      </div>
      <div class="flex-1 py-2 pl-10 pr-6 bg-white rounded mdmax:pl-3 mdmax:pr-3" :class="{ arrow: !isMobile }">
        <p class="text-sm font-medium ">Logistik & Pembayaran</p>
        <p class="text-xs text-neutral-500">Pilih logistik dan bayar</p>
      </div>
    </div>
    <div class="flex items-stretch bg-white shadow-border-b mdmax:flex-col">
      <div class="w-1/2 shadow-border-r p-6 mdmax:px-4 mdmax:shadow-none mdmax:w-full">
        <!-- Card Pengirim -->
        <p class="font-bold mb-4">Informasi Pengirim</p>
        <div class="bg-white border border-neutral-200 rounded-xl shadow-sm overflow-hidden mb-6">
          <div class="p-5 cursor-pointer hover:bg-neutral-50 transition-colors" @click="openAddressFormModal('sender')">
            <div class="flex items-start gap-4">
              <div class="mt-1">
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#2D3748">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
                </svg>
              </div>
              <div class="flex-1">
                <div v-if="selectedAddress">
                  <p class="font-bold text-neutral-800 text-lg mb-1 flex items-center gap-2">
                    {{ selectedAddress.sender_name }}
                    <span class="text-sm text-neutral-500 font-normal">{{ selectedAddress.sender_phone || selectedAddress.phone }}</span>
                  </p>
                  <p class="text-sm text-neutral-600 mb-1 leading-relaxed">{{ selectedAddress.address }}</p>
                  <p class="text-sm text-neutral-500">{{ selectedAddress.area ? (selectedAddress.area.village + ', ' + selectedAddress.area.area_display) : '' }}</p>
                </div>
                <div v-else>
                  <p class="font-bold text-neutral-800 text-lg mb-1">Pengirim</p>
                  <p class="text-sm text-neutral-500">Pilih atau isi informasi pengirim</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Card Penerima -->
        <p class="font-bold mb-4">Informasi Penerima</p>
        <div class="bg-white border border-neutral-200 rounded-xl shadow-sm overflow-hidden mb-6">
          <div class="p-5 cursor-pointer hover:bg-neutral-50 transition-colors" @click="openAddressFormModal('receiver')">
            <div class="flex items-start gap-4">
              <div class="mt-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="#2D3748" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z" stroke="#2D3748" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="flex-1">
                <div v-if="receiverName && receiverPhoneNumber && payloads.destination_city">
                  <p class="font-bold text-neutral-800 text-lg mb-1 flex items-center gap-2">
                    {{ receiverName }}
                    <span class="text-sm text-neutral-500 font-normal">{{ receiverPhoneNumber }}</span>
                  </p>
                  <p class="text-sm text-neutral-600 mb-1 leading-relaxed" v-if="addressDetail">{{ addressDetail }}</p>
                  <p class="text-sm text-neutral-500">{{ payloads.destination_city ? (payloads.destination_city.village + ', ' + payloads.destination_city.area_display) : '' }}</p>
                </div>
                <div v-else>
                  <p class="font-bold text-neutral-800 text-lg mb-1">Penerima</p>
                  <p class="text-sm text-neutral-500">Pilih atau isi informasi penerima</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-1/2 p-6 mdmax:px-4 mdmax:w-full">
        <p class="font-bold mb-4">{{ $t('order.createOrder.stepOne.serviceType') }}</p>
        <!-- <div class="flex justify-between items-center mb-5">
          <p class="text-sm font-medium">Kirim nanti?</p>
          <div class="flex gap-2 items-center">
            <Toggle v-model="isScheduleOrder" id="schedule" />
            <p class="text-neutral-500 text-sm font-medium">{{ isScheduleOrder ? 'On' : 'Off' }}</p>
          </div>
        </div> -->
        <div v-if="isScheduleOrder" class="mb-6 flex items-center gap-4">
          <div class="w-1/2">
            <TextField type="date" :min="today" v-model="scheduleDate" :label="$t('order.createOrder.stepOne.pickupDate')" />
          </div>
          <div class="custom-select w-1/2">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">{{ $t('order.createOrder.stepOne.pickupTime') }}</label>
            <v-select :options="pickupSlotTime" :placeholder="$t('order.createOrder.stepOne.pickupTimePlaceholder')" label="display" v-model="scheduleTime" />
          </div>
        </div>
        <div class="mb-6 custom-select">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">{{ $t('order.createOrder.stepOne.packageType') }}</label>
          <v-select
            :options="goodsCategories"
            :placeholder="$t('order.createOrder.stepOne.packageTypePlaceholder')"
            :reduce="selectedPackage => selectedPackage.code"
            label="name"
            v-model="selectedPackage"
          />
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-4 inline-block">Ukuran dan Dimensi Paket</label>
          <div class="mb-4">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">{{ $t('order.createOrder.stepOne.modal.weight') }} <span class="text-red-500">*</span></label>
            <div class="relative">
              <TextField 
                type="text" 
                inputmode="decimal" 
                withIcon 
                :placeholder="$t('order.createOrder.stepOne.modal.weightPlaceholder')" 
                v-model="custom.weight" 
                @input="handleWeightInput"
              />
              <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
                <Box />
              </div>
              <div class="absolute right-3 top-1/2 transform -translate-y-1/2">
                Kg
              </div>
            </div>
          </div>
          <div class="flex gap-4 mb-4">
            <div class="flex-1">
              <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">{{ $t('order.createOrder.stepOne.modal.length') }} <span class="text-red-500">*</span></label>
              <div class="relative">
                <TextField type="text" inputmode="numeric" placeholder="0" v-model="custom.length" @input="handleDimensionInput('length', $event)" />
                <div class="absolute right-3 top-1/2 transform -translate-y-1/2">
                  cm
                </div>
              </div>
            </div>
            <div class="flex-1">
              <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">{{ $t('order.createOrder.stepOne.modal.width') }} <span class="text-red-500">*</span></label>
              <div class="relative">
                <TextField type="text" inputmode="numeric" placeholder="0" v-model="custom.width" @input="handleDimensionInput('width', $event)" />
                <div class="absolute right-3 top-1/2 transform -translate-y-1/2">
                  cm
                </div>
              </div>
            </div>
            <div class="flex-1">
              <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">{{ $t('order.createOrder.stepOne.modal.height') }} <span class="text-red-500">*</span></label>
              <div class="relative">
                <TextField type="text" inputmode="numeric" placeholder="0" v-model="custom.height" @input="handleDimensionInput('height', $event)" />
                <div class="absolute right-3 top-1/2 transform -translate-y-1/2">
                  cm
                </div>
              </div>
            </div>
          </div>
          <div class="p-3 bg-neutral-100 rounded-md border border-neutral-200 flex justify-between items-center" v-if="custom.length > 0 && custom.width > 0 && custom.height > 0">
            <p class="text-sm text-neutral-500 font-medium">Berat Volume</p>
            <p class="text-sm font-semibold text-neutral-600">{{ volumetricWeight }} Kg</p>
          </div>
        </div>
        <!-- <div class="flex justify-between items-center mb-5">
          <p class="text-sm font-medium">Apakah ada pengiriman surat jalan (POD)?</p>
          <div class="flex gap-2 items-center">
            <Toggle v-model="isPOD" id="pod" />
            <p class="text-neutral-500 text-sm font-medium">{{ isPOD ? 'On' : 'Off' }}</p>
          </div>
        </div> -->
        <div v-if="isPOD" class="mb-6 flex items-center gap-4 w-full">
          <div class="text-sm w-full p-4 flex items-center gap-2 bg-secondary-100 text-neutral-700 rounded-md">
            <Info width="24" height="24" color="neutral-700" />
            {{ $t('order.createOrder.stepOne.pod') }}
          </div>
        </div>
      </div>
    </div>
    <div class="flex items-center p-6 justify-end bg-white gap-4">
      <Button :buttonText="$t('order.createOrder.stepOne.cancel')" type="secondary" @action="cancelCreateOrder()" />
      <Button :buttonText="$t('order.createOrder.stepOne.next')" :disabled="isDisabled" type="primary" @action="goToStep2()" />
    </div>
    <Modal :modalVisible="visibleAddressModal" @close="toggleAddressFormModal" id="address-form-modal" :overflowAuto="false">
      <template slot="modal-content">
        <AddressFormModal 
          v-if="visibleAddressModal"
          :type="addressModalType" 
          :initialData="addressModalInitialData"
          @close="toggleAddressFormModal" 
          @apply="handleAddressFormApply" 
        />
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
// import VueGoogleAutocomplete from 'vue-google-autocomplete'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import dayjs from 'dayjs'
import { isNotEmptyError } from '@/util/form-validator'
const NOW = new Date()
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Box: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Box'),
    // Place: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Place'),
    // Toggle: () => import(/* webpackChunkName: "Toggle" */ '@/components/Toggle/Toggle'),
    // CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    Info: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Info'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/Modal/Modal'),
    AddressFormModal: () => import(/* webpackChunkName: "AddressFormModal" */ '@/views/Order/AddressFormModal'),
    vSelect
    // VueGoogleAutocomplete
  },
  data: () => ({
    addressModalType: 'sender',
    addressModalInitialData: null,
    isUsingExistingReceiverAddress: false,
    visibleAddressModal: false,
    scheduleDate: null,
    scheduleTime: null,
    receiverName: null,
    receiverPhoneNumber: null,
    visibleCustom: false,
    goodsWeight: 0,
    addressDetail: null,
    packageList: ['a', 'b'],
    selectedPackage: null,
    selectedAddress: null,
    receiverAddress: null,
    searchKeyword: null,
    isSearchingPlace: false,
    selectedPackageSize: null,
    isFetching: false,
    payloads: {
      name: '',
      location: '',
      email: '',
      origin_city: null,
      destination_city: null
    },
    debounce: null,
    origin: '',
    originSearch: '',
    destination: '',
    destinationSearch: '',
    cityKeyword: null,
    visibleSuggestion: {
      origin: false,
      destination: false,
      senderAddress: false
    },
    isSearching: {
      origin: false,
      destination: false,
      senderAddress: false
    },
    senderAddressSearch: '',
    senderAddressKeyword: '',
    orderStep: ['shipping', 'logistic', 'confirmation'],
    address: null,
    autocomplete: null,
    autocompleteService: null,
    placeService: null,
    sessionToken: null,
    suggestionList: [],
    localStorageAsync: {
      set: function(key, value) {
        return Promise.resolve().then(function() {
          localStorage.setItem(key, value)
        })
      },
      get: function(key) {
        return Promise.resolve().then(function() {
          return localStorage.getItem(key)
        })
      }
    },
    custom: {
      weight: null,
      length: null,
      width: null,
      height: null
    },
    isScheduleOrder: false,
    isPOD: false
  }),
  computed: {
    ...mapGetters('master', ['cities', 'packageSizes', 'goodsCategories', 'pickupSlotTime']),
    ...mapGetters('merchant', ['addresses', 'isAddressModalVisible']),
    ...mapGetters('common', ['isMobile']),
    isStepAvailable() {
      return this.orderStep.indexOf(this.$route.params.step) > -1
    },
    defaultAddress() {
      return this.addresses.filter(item => item.is_main)[0]
    },
    isFirstStep() {
      return this.$route.params.step === 'shipping'
    },
    isSecondStep() {
      return this.$route.params.step === 'logistic'
    },
    isThirdStep() {
      return this.$route.params.step === 'confirmation'
    },
    isCustomDisabled() {
      return !this.validForm(this.custom)
    },
    isDisabled() {
      const cleanPhone = this.normalizePhoneNumber(this.receiverPhoneNumber)
      const weightVal = parseFloat(String(this.custom.weight || '').replace(',', '.'))
      const lengthVal = parseFloat(String(this.custom.length || '').replace(',', '.'))
      const widthVal = parseFloat(String(this.custom.width || '').replace(',', '.'))
      const heightVal = parseFloat(String(this.custom.height || '').replace(',', '.'))

      return (
        !this.selectedAddress ||
        !this.receiverName ||
        !this.receiverPhoneNumber ||
        cleanPhone.length > 15 ||
        cleanPhone.length < 8 ||
        (!this.destinationSearch && !this.payloads.destination_city) ||
        !this.addressDetail ||
        !this.selectedPackage ||
        !this.custom.weight ||
        isNaN(weightVal) ||
        weightVal <= 0 ||
        !this.custom.length ||
        isNaN(lengthVal) ||
        lengthVal <= 0 ||
        !this.custom.width ||
        isNaN(widthVal) ||
        widthVal <= 0 ||
        !this.custom.height ||
        isNaN(heightVal) ||
        heightVal <= 0 ||
        (this.isScheduleOrder && !this.scheduleDate) ||
        (this.isScheduleOrder && !this.scheduleTime)
      )
    },
    today() {
      return dayjs(new Date()).format('YYYY-MM-DD')
    },
    volumetricWeight() {
      const p = parseFloat(String(this.custom.length || 0).replace(',', '.'))
      const l = parseFloat(String(this.custom.width || 0).replace(',', '.'))
      const t = parseFloat(String(this.custom.height || 0).replace(',', '.'))
      return Math.ceil((p * l * t) / 6000)
    }
  },
  async mounted() {
    this.hideLoading()
    // eslint-disable-next-line
    this.sessionToken = new google.maps.places.AutocompleteSessionToken()
    // eslint-disable-next-line
    this.autocompleteService = new google.maps.places.AutocompleteService()
    // eslint-disable-next-line
    this.placeService = new google.maps.places.PlacesService(document.createElement('div'))

    const getShipping = JSON.parse(localStorage.getItem('order_shipping'))
    let data
    if (getShipping) {
      data = getShipping
    } else if (this.$route.query.draft) {
      await this.getDraftOrderDetail({
        draftOrderId: this.$route.query.draft
      }).then(response => {
        data = JSON.parse(response.data.data.order_shipping)
        if (data) {
          this.localStorageAsync.set('order_shipping', JSON.stringify(data))
        }
        if (response.data.data.order_logistic) {
          this.localStorageAsync.set('order_logistic', response.data.data.order_logistic)
        }
      })
    }

    if (data) {
      this.selectedAddress = data.sender
      if (this.selectedAddress) {
        const normSenderPhone = this.normalizePhoneNumber(this.selectedAddress.sender_phone || this.selectedAddress.phone)
        this.selectedAddress.sender_phone = normSenderPhone
        this.selectedAddress.phone = normSenderPhone
      }
      this.senderAddressSearch = data.sender?.location_label
      this.isUsingExistingReceiverAddress = data.isUsingExistingReceiverAddress
      this.isPOD = data.is_require_pod
      if (data.isUsingExistingReceiverAddress) {
        this.receiverAddress = data.receiver?.selectedAddress
        if (this.receiverAddress) {
          const normRecPhone = this.normalizePhoneNumber(this.receiverAddress.sender_phone || this.receiverAddress.phone)
          this.receiverAddress.sender_phone = normRecPhone
          this.receiverAddress.phone = normRecPhone
        }
      }
      this.receiverName = data.receiver?.name
      this.receiverPhoneNumber = this.normalizePhoneNumber(data.receiver?.phone)
      this.goodsWeight = data.receiver?.weight
      this.searchKeyword = data.receiver?.location?.name
      this.address = {
        name: data.receiver?.location?.name,
        latitude: data.receiver?.location?.latitude,
        longitude: data.receiver?.location?.longitude
      }
      this.addressDetail = data.receiver?.addressDetail
      this.originSearch = data.hub.origin ? `${data.hub?.origin?.village}, ${data.hub?.origin?.area_display}` : ''
      this.destinationSearch = data.hub.destination ? `${data.hub?.destination?.village}, ${data.hub?.destination?.area_display}` : ''
      this.payloads.origin_city = data.hub.origin
      this.payloads.destination_city = data.hub.destination
      this.selectedPackage = data.hub.goodsCategory
      this.selectedPackageSize = data.package
      if (this.selectedPackageSize.code === 'CUSTOM') {
        this.custom.weight = data.receiver?.weight
        const dim = this.selectedPackageSize.dimension.split('x')
        this.custom.length = dim[0]
        this.custom.width = dim[1]
        this.custom.height = dim[2]
      }
      if (data.is_advance_pickup) {
        this.isScheduleOrder = true
        this.scheduleDate = data.pickup_date
        this.scheduleTime = data.pickup_slot_id
      }
    }
  },
  created() {
    this.getPackageSizeList()
    this.getGoodsCategoryList()
    // this.getSenderAddress()
    this.getPickupSlotTimeList()
  },
  methods: {
    ...mapActions('master', ['getCities', 'getPackageSizes', 'getGoodsCategories', 'getPickupSlotTime']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    ...mapActions('merchant', ['getAddresses', 'getDeliveryServices', 'toggleAddressModal']),
    ...mapActions('order', ['getDraftOrderDetail']),
    manualInput() {
      this.isUsingExistingReceiverAddress = false
      this.receiverAddress = null
      this.receiverName = null
      this.receiverPhoneNumber = null
      this.destinationSearch = ''
      this.addressDetail = null
    },
    toggleAddressFormModal() {
      this.visibleAddressModal = !this.visibleAddressModal
    },
    openAddressFormModal(type) {
      this.addressModalType = type
      
      if (type === 'sender' && this.selectedAddress) {
        const normSenderPhone = this.normalizePhoneNumber(this.selectedAddress.sender_phone || this.selectedAddress.phone)
        this.addressModalInitialData = { 
          isSavedAddress: true, 
          addressObj: {
            ...this.selectedAddress,
            sender_phone: normSenderPhone,
            phone: normSenderPhone
          }
        }
      } else if (type === 'receiver' && this.isUsingExistingReceiverAddress && this.receiverAddress) {
        const normRecPhone = this.normalizePhoneNumber(this.receiverAddress.sender_phone || this.receiverAddress.phone || this.receiverPhoneNumber)
        this.addressModalInitialData = { 
          isSavedAddress: true, 
          addressObj: {
            ...this.receiverAddress,
            sender_phone: normRecPhone,
            phone: normRecPhone
          }
        }
      } else if (type === 'receiver' && !this.isUsingExistingReceiverAddress && this.receiverName) {
        this.addressModalInitialData = {
          isSavedAddress: false,
          data: {
            name: this.receiverName,
            phone: this.normalizePhoneNumber(this.receiverPhoneNumber),
            area: this.payloads.destination_city,
            address: this.addressDetail
          }
        }
      } else {
        this.addressModalInitialData = null
      }
      
      this.visibleAddressModal = true
    },
    normalizePhoneNumber(phone) {
      if (!phone) return ''
      let digits = String(phone).replace(/\D/g, '')
      if (digits.startsWith('0062')) {
        digits = digits.slice(4)
        if (digits.startsWith('0')) digits = digits.slice(1)
        digits = '0' + digits
      } else if (digits.startsWith('620')) {
        digits = '0' + digits.slice(3)
      } else if (digits.startsWith('62')) {
        digits = '0' + digits.slice(2)
      } else if (digits.startsWith('8')) {
        digits = '0' + digits
      }
      return digits
    },
    handleAddressFormApply(payload) {
      if (this.addressModalType === 'sender') {
        if (payload.isSavedAddress) {
          const normPhone = this.normalizePhoneNumber(payload.addressObj.sender_phone || payload.addressObj.phone)
          this.selectedAddress = {
            ...payload.addressObj,
            sender_phone: normPhone,
            phone: normPhone
          }
          this.senderAddressSearch = payload.addressObj.location_label
        } else {
          const normPhone = this.normalizePhoneNumber(payload.data.phone)
          this.selectedAddress = {
            location_label: payload.data.label,
            sender_name: payload.data.name,
            sender_phone: normPhone,
            phone: normPhone,
            address: payload.data.address,
            area: payload.data.area,
            detail_address: ''
          }
          this.senderAddressSearch = payload.data.label
        }
      } else if (this.addressModalType === 'receiver') {
        if (payload.isSavedAddress) {
          this.isUsingExistingReceiverAddress = true
          this.receiverAddress = payload.addressObj
          this.receiverName = payload.addressObj.sender_name || payload.addressObj.receiver_name || payload.addressObj.name
          this.receiverPhoneNumber = this.normalizePhoneNumber(payload.addressObj.sender_phone || payload.addressObj.phone)
          this.payloads.destination_city = payload.addressObj.area
          this.addressDetail = payload.addressObj.address
          this.destinationSearch = payload.addressObj.area ? `${payload.addressObj.area.village}, ${payload.addressObj.area.area_display}` : ''
        } else {
          this.isUsingExistingReceiverAddress = false
          this.receiverAddress = null
          this.receiverName = payload.data.name
          this.receiverPhoneNumber = this.normalizePhoneNumber(payload.data.phone)
          this.payloads.destination_city = payload.data.area
          this.addressDetail = payload.data.address
          this.destinationSearch = payload.data.area ? `${payload.data.area.village}, ${payload.data.area.area_display}` : ''
        }
      }
      this.toggleAddressFormModal()
    },
    validatePhoneNumber(event) {
      const value = event.target.value.replace(/\D/g, '') // keep only digits
      if (value.length > 15) {
        event.target.value = value.slice(0, 15) // trim to max 15 digits
      }
    },
    getPickupSlotTimeList() {
      this.getPickupSlotTime()
    },
    numbersOnly(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    addAddress() {
      this.toggleAddressModal({
        state: !this.isAddressModalVisible,
        mode: 'RELOAD'
      })
    },
    validForm(payload) {
      const error = isNotEmptyError(payload)
      return Object.keys(error).length === 0
    },
    toggleCustomModal() {
      this.visibleCustom = !this.visibleCustom
    },
    cancelCreateOrder() {
      this.showLoading()
      localStorage.removeItem('order_shipping')
      setTimeout(() => {
        this.hideLoading()
        this.$router.push('/order')
      }, 1000)
    },
    goBack(target) {
      this.showLoading()
      setTimeout(() => {
        this.$router.push(`/order/step/${target}`)
        this.hideLoading()
      }, 1000)
    },
    // getSenderAddress() {
    //   this.getAddresses({
    //     params: {
    //       location_label: ''
    //     }
    //   }).then(() => {
    //     const data = JSON.parse(localStorage.getItem('order_shipping'))
    //     if (!data) {
    //       this.selectedAddress = this.defaultAddress
    //     } else {
    //       this.selectedAddress = data.sender
    //     }
    //   })
    // },
    selectPackageSize(size) {
      if (size.code === 'CUSTOM') {
        this.toggleCustomModal()
      } else {
        this.goodsWeight = size.max_weight
        this.selectedPackageSize = size
      }
    },
    applyCustom() {
      const customPackage = this.packageSizes.filter(item => item.code === 'CUSTOM')[0]
      customPackage.dimension = `${this.custom.length}x${this.custom.width}x${this.custom.height}`
      this.goodsWeight = this.custom.weight
      this.selectedPackageSize = customPackage
      this.toggleCustomModal()
    },
    displaySuggestions(value) {
      this.suggestionList = value
    },
    searchPlace(input) {
      if (this.searchKeyword !== '') {
        clearTimeout(this.debounce)
        let self = this
        this.debounce = setTimeout(() => {
          if (this.searchKeyword !== '') {
            this.isSearchingPlace = true
            this.autocompleteService.getPlacePredictions(
              {
                input: self.searchKeyword,
                sessionToken: self.sessionToken,
                componentRestrictions: { country: 'id' }
              },
              this.displaySuggestions
            )
          }
        }, 300)
      } else {
        this.isSearchingPlace = false
      }
    },
    selectPlace(place) {
      let request = {
        placeId: place.place_id,
        fields: ['name', 'geometry', 'formatted_address']
      }
      this.autocompleteService.get
      this.searchKeyword = place.description
      this.isSearchingPlace = false
      this.placeService.getDetails(request, this.setAddress)
    },
    setAddress(place) {
      this.address = {
        name: place.formatted_address,
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng()
      }
    },
    async goToStep2() {
      const customPackage = this.packageSizes.find(item => item.code === 'CUSTOM')
      let packageSizeObj = null
      if (customPackage) {
        packageSizeObj = { ...customPackage }
        packageSizeObj.dimension = `${this.custom.length}x${this.custom.width}x${this.custom.height}`
      }

      const normalizedSenderPhone = this.selectedAddress 
        ? this.normalizePhoneNumber(this.selectedAddress.sender_phone || this.selectedAddress.phone)
        : ''
      const normalizedReceiverPhone = this.normalizePhoneNumber(this.receiverPhoneNumber)

      const senderData = this.selectedAddress ? {
        ...this.selectedAddress,
        sender_phone: normalizedSenderPhone,
        phone: normalizedSenderPhone
      } : null

      let receiverAddressData = null
      if (this.isUsingExistingReceiverAddress && this.receiverAddress) {
        receiverAddressData = {
          ...this.receiverAddress,
          sender_phone: normalizedReceiverPhone,
          phone: normalizedReceiverPhone
        }
      }

      let data = {
        isUsingExistingReceiverAddress: this.isUsingExistingReceiverAddress,
        is_advance_pickup: this.isScheduleOrder,
        is_require_pod: this.isPOD,
        sender: senderData,
        receiver: {
          name: this.receiverName,
          phone: normalizedReceiverPhone,
          weight: this.custom.weight,
          location: {
            name: '',
            latitude: '',
            longitude: ''
          },
          addressDetail: this.addressDetail
        },
        hub: {
          origin: this.selectedAddress ? this.selectedAddress.area : null,
          destination: this.isUsingExistingReceiverAddress ? this.receiverAddress?.area : this.payloads.destination_city,
          goodsCategory: this.selectedPackage
        },
        package: packageSizeObj
      }
      if (this.isScheduleOrder) {
        data.pickup_slot_id = this.scheduleTime
        data.pickup_date = this.scheduleDate
      } else {
        if (data.pickup_date) delete data.pickup_date
        if (data.pickup_slot_id) delete data.pickup_slot_id
      }
      if (this.isUsingExistingReceiverAddress && receiverAddressData) {
        data.receiver.selectedAddress = receiverAddressData
      }

      this.showLoading()
      this.localStorageAsync.set('order_shipping', JSON.stringify(data)).then(() => {
        setTimeout(() => {
          this.hideLoading()
          this.$router.push(`/order/step/logistic${this.$route.query.draft ? `?draft=${this.$route.query.draft}` : ''}`)
        }, 1000)
      })
    },
    getGoodsCategoryList() {
      this.getGoodsCategories()
    },
    getPackageSizeList() {
      this.showLoading()
      this.getPackageSizes().then(() => {
        this.hideLoading()
        const data = JSON.parse(localStorage.getItem('order_shipping'))

        if (data) {
          this.selectedPackageSize = data.package
          if (this.selectedPackageSize.code === 'CUSTOM') {
            this.custom.weight = data.receiver?.weight
            const dim = this.selectedPackageSize.dimension.split('x')
            this.custom.length = dim[0]
            this.custom.width = dim[1]
            this.custom.height = dim[2]
          }
        }
      })
    },
    searchAddress(value, target) {
      this.senderAddressKeyword = null
      if (value) this.isSearching[target] = true
      this.visibleSuggestion[target] = false
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        if (value) {
          this.senderAddressKeyword = value
          this.getAddresses({
            params: {
              location_label: this.senderAddressKeyword
            }
          }).then(() => {
            this.visibleSuggestion[target] = true
            this.isSearching[target] = false
          })
        }
      }, 800)
    },
    selectAddress(data, target) {
      this.senderAddressSearch = data.location_label
      this.selectedAddress = data
      this.visibleSuggestion[target] = false
    },
    searchCity(value, target) {
      this.cityKeyword = null
      if (value) this.isSearching[target] = true
      this.visibleSuggestion[target] = false
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        if (value) {
          this.cityKeyword = value
          this.getCities({
            params: {
              page: 1,
              per_page: 1000,
              search_keyword: this.cityKeyword
            }
          }).then(() => {
            this.visibleSuggestion[target] = true
            this.isSearching[target] = false
          })
        }
      }, 800)
    },
    selectCity(data, target) {
      if (target === 'origin') {
        this.payloads.origin_city = data
        this.originSearch = `${data.village}, ${data.area_display}`
      } else {
        this.payloads.destination_city = data
        this.destinationSearch = `${data.village}, ${data.area_display}`
      }
      this.visibleSuggestion[target] = false
    }
  }
}
</script>
<style lang="scss" scoped>
.arrow {
  margin: 0 0 0 -12px;
  -webkit-clip-path: polygon(20px 50%, 0% 0%, calc(100% - 20px) 0%, 100% 50%, calc(100% - 20px) 100%, 0% 100%);

  &:first-child {
    -webkit-clip-path: polygon(0% 0%, calc(100% - 20px) 0%, 100% 50%, calc(100% - 20px) 100%, 0% 100%);
  }

  &:last-child {
    -webkit-clip-path: polygon(20px 50%, 0% 0%, 100% 0%, 100% 100%, 0% 100%);
  }
}

.stepper {
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    content: '';
  }
}

.place {
  &::v-deep input {
    padding: 12px 12px 12px 44px;
    outline: none;
    border-radius: 8px;
    border: 1px solid #ced5de;
    width: 100%;
  }
}

.custom-select {
  &::v-deep .vs__dropdown-toggle {
    padding: 12px;
    border-radius: 8px;
  }

  &::v-deep .vs__actions {
    padding: 0;
  }

  &::v-deep .vs__search,
  &::v-deep .vs__selected {
    padding: 0;
    margin: 0;
  }

  &::v-deep .vs__search::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #748497;
    opacity: 1;
    /* Firefox */
  }
}
</style>
